import _extends from "@babel/runtime/helpers/extends";
import _GalleryOptions from './ProGallery.options.json';
import _GallerySections from './ProGallery.sectionOptions.json';
import _GalleryOptionsGen from './ProGallery.autoGeneratedOptions.json';
// @ts-expect-error
delete _GalleryOptions.$schema;

// @ts-expect-error
delete _GallerySections.$schema;

// @ts-expect-error
delete _GalleryOptionsGen.$schema;
export const ProGalleryOptions = _extends({}, _GalleryOptions, _GalleryOptionsGen);
export const ProGallerySettingsOptions = _extends({}, ProGalleryOptions, _GallerySections, _GalleryOptionsGen);
export const processProGalleryOptions = options => _extends({}, Object.values(ProGalleryOptions).reduce((defaults, option) => _extends({}, defaults, {
  [option.key]: option.default
}), {}), options);
//# sourceMappingURL=ProGallery.options.js.map